import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/** Opções de linhas por página oferecidas em todas as tabelas paginadas. */
const PAGE_SIZE_OPTIONS: number[] = [10, 20, 50, 100];

interface PageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
}

/**
 * Seletor de linhas por página usado no rodapé das tabelas paginadas. Apenas
 * dispara `onChange` com o novo tamanho — o chamador é quem reseta a página para 1.
 */
export default function PageSizeSelect({
  value,
  onChange,
}: PageSizeSelectProps) {
  return (
    <div className="flex items-center gap-2 text-xs text-slate-600">
      <span>Linhas por página</span>
      <Select
        value={String(value)}
        onValueChange={next => onChange(Number(next))}
      >
        <SelectTrigger className="h-8 w-[72px] bg-white text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map(option => (
            <SelectItem key={option} value={String(option)} className="text-xs">
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
